export default (_, env = 'dev') => ({
  auth: {
    realm: 'cx',
    url: `https://login.${env}.cx-apps.io/auth`,
    clientId: 'cx-apps',
    relativePath: '/auth'
  }
});
